const defaultMinZoom = 2;
const defaultMaxZoom = 12;

import * as AzAtlas from 'azure-maps-control';
const { data: AzData } = AzAtlas;

const keysToCompare = ["duration", "maxBounds", "bounds", "type", "zoom", "center", "minZoom", "maxZoom", "pitch"];

const areSame = (a, b) => {
    if (!a || !b) return false;
    for (let key of keysToCompare) {
        const aa = a[key];
        const bb = b[key];

        if (aa === undefined && bb === undefined)
            continue;
        else if (typeof aa !== typeof bb || aa === undefined || bb === undefined)
            return false;
        else if (Array.isArray(aa)) {
            if (aa.length !== bb.length || aa.some((value, index) => value !== bb[index])) {
                return false;
            }
        }
        else if (aa !== bb)
            return false;
    }

    return true;
}

export const flyToStartupCoordinates = (state) => {
    const { mapConfig, map, zoombox, attackData, defaultCamera, pitch } = state;

    if (!map || !(mapConfig || zoombox)) {
        return;
    }

    let positioning = {
        duration: 2000,
        maxBounds: [-179, -60, 180, 80],
        type: 'fly'
    };

    const { zoom, longitude, latitude, minZoom, maxZoom, isDataCentric, skipCameraPositioning } = mapConfig || {};

    const isAttackActive = attackData && attackData.length > 0

    const previousCamera = map?.getCamera();

    if (pitch !== undefined && pitch !== null) {
        positioning.pitch = pitch;
        if (pitch != 0)
        {
            positioning.maxBounds = null;
        }
        
        if (previousCamera && previousCamera.pitch !== pitch) 
        {
            positioning.type = 'ease'
        }

    } else {
        positioning.pitch = 0;
        if (previousCamera && previousCamera.pitch !== pitch) {
            positioning.type = 'ease'
        }
    }

    if (isAttackActive) {
        map.setCamera(defaultCamera);
        return;
    }

    if (zoombox && !isAttackActive) {
        let {
            "top-left-longitude": topLeftLong,
            "top-left-latitude": topLeftLat,
            "bottom-right-longitude": bottomRightLong,
            "bottom-right-latitude": bottomRightLat,
        } = zoombox;

        const longitudeDistance = bottomRightLong - topLeftLong;
        if (longitudeDistance > 180) { // over than half a globe, flip viewport
            const perSideAdjustment = (0.8 * longitudeDistance) / 2;
            bottomRightLong = bottomRightLong - perSideAdjustment;
            topLeftLong = topLeftLong + perSideAdjustment;
        }

        const topLeft = {
            type: "Point",
            coordinates: [topLeftLong, topLeftLat]
        }

        const bottomRight = {
            type: "Point",
            coordinates: [bottomRightLong, bottomRightLat]
        };

        positioning.bounds = AzData.BoundingBox.fromData([topLeft, bottomRight]);
    } else if (zoom && longitude) {
        positioning.zoom = zoom;
        positioning.center = [longitude, latitude];
        positioning.minZoom = minZoom ?? defaultMinZoom;
        positioning.maxZoom = maxZoom ?? defaultMaxZoom;

        if (positioning.minZoom > positioning.maxZoom) {
            throw new Error(`Min zoom '${positioning.minZoom}' is larger than max zoom '${positioning.maxZoom}'`);
        }
        if (positioning.minZoom > zoom) {
            throw new Error(`Min zoom '${positioning.minZoom}' is larger than requested '${zoom}' zoom`);
        }

        if (isDataCentric) {
            const { displayedData } = state;
            if (displayedData) {
                const { features } = displayedData;
                if (features) {
                    let viewPorted = features.filter(feature => !feature.properties.hasOwnProperty("skipViewPort"));
                    if (viewPorted.length > 1) {
                        positioning.bounds = AzData.BoundingBox.fromData(viewPorted);
                        delete positioning.center;
                    }
                }
            }
        }
    }
    else {
        if (!skipCameraPositioning)
            console.debug('Niether zoombox, nor center coordinates are supplied to set camera');

        return;
    }

    if (!areSame(map.rawPosition, positioning)) {
        //map.rawPosition = positioning;
        map.setCamera(positioning);
    }
}